export default __webpack_public_path__ + "static/media/warning-triangle-orange.fdf55407.svg";